module.exports = __webpack_public_path__ + "img/ic-usdc.618558dd.svg";